import { Form, Row, Col, Input } from "antd";
import React from "react";
import BannerCard from "../../../common/components/BannerCard";

const JudgeDetail = ({ ...props }) => {
  const { form } = props;
  return (
    <BannerCard title="Judge Detail">
      <Form form={form} layout="vertical">
        <Row gutter={16}>
          <Col xl={12} lg={12} md={12} sm={12} xs={24}>
            <Form.Item name="JudgeName" label="Judge">
              <Input readOnly />
            </Form.Item>
          </Col>
          <Col xl={6} lg={6} md={6} sm={6} xs={24}>
            <Form.Item name="CaseNextStatusDateTime" label="Date">
              <Input readOnly />
            </Form.Item>
          </Col>
          <Col xl={6} lg={6} md={6} sm={6} xs={24}>
            <Form.Item name="CaseNextStatusTime" label="Time">
              <Input readOnly />
            </Form.Item>
          </Col>
          <Col xl={12} lg={12} md={12} sm={12} xs={24}>
            <Form.Item name="CaseStatusDesc" label="Status">
              <Input readOnly />
            </Form.Item>
          </Col>
          <Col xl={12} lg={12} md={12} sm={12} xs={24}>
            <Form.Item name="ActionSummary" label="Action">
              <Input.TextArea readOnly rows={3} />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </BannerCard>
  );
};

export default JudgeDetail;
